export default "/assets/images/filter-recommandation-BS.webp?8bfe57427784da702873c29c29c9c80f";